import { useState } from "react";
import InventoryMovementService from "../../../api/Inventory/InventoryMovementService";
import useLoading from "../../../components/Common/useLoading";
import { PaginationResult } from "../../../api/Common/Util";

const defaultProps = {
    itemId: null,
    pageNumber: 1,
    pageSize: 5
}

export default function useItemHistoryOfMovements(props = defaultProps) {
    const [request, setRequest] = useState(props)
    const [history, setHistory] = useState(new PaginationResult());
    const [isLoading, withLoad, doReaload] = useLoading({
        onLoad: async () => {
            await findHistory(props);
        }
    });

    const Navigation = {
        ToPage: async ({ page }) => {
            const newRequest = history.ToPage(page);
            if (newRequest == null) return
            setRequest({ ...request, ...newRequest })
            await withLoad(() => findHistory({ ...request, ...newRequest }))
        },
        Reload: async () => {
            await withLoad(() => findHistory(request))
        }
    }

    const findHistory = async ({ itemId, pageNumber, pageSize }) => {
        const result = await InventoryMovementService.InventoryItemHistory({ itemId: itemId, pageNumber: pageNumber, pageSize: pageSize });
        setHistory(result);
    }

    return [history, isLoading, Navigation];
}